// FNP-1960: the metering-record, notification-subscription, offer and
// registration actions went with their modules, and DeleteProduct with the old
// products module (drafts have no delete). Each action here must also be in the
// AVP schema in flexinet-marketplace-avp-infra, or a non-admin is denied.
export const actions = [
    'ViewDashboard',
    'ViewProfile',

    'ListProducts',
    'GetProduct',
    'CreateProduct',
    'UpdateProduct',

] as const;

// FNP-1934: the union of every action this app checks. A check that names an
// action outside this list fails to compile instead of silently denying.
export type RbacAction = typeof actions[number];

export const isRbacAction = (value: unknown): value is RbacAction =>
    typeof value === 'string' && (actions as readonly string[]).includes(value);
